import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SET_USER_PERMISSIONS,
  CLEAR_USER_PERMISSIONS,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  user: null,
  permissions: {},
  enabledModules: {},
  groups: [],
  isAuthenticated: false,
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        user: action.payload,
        permissions: action.payload?.permissions || {},
        enabledModules: action.payload?.enabled_modules || {},
        groups: action.payload?.groups || [],
        isAuthenticated: true,
      }
      break
    case LOGOUT_USER:
      state = { ...state }
      break
    case LOGOUT_USER_SUCCESS:
      state = {
        ...initialState,
      }
      break
    case SET_USER_PERMISSIONS:
      state = {
        ...state,
        user: action.payload.user,
        permissions: action.payload.permissions || {},
        enabledModules: action.payload.enabledModules || state.enabledModules || {},
        groups: action.payload.groups || [],
        isAuthenticated: true,
      }
      break
    case CLEAR_USER_PERMISSIONS:
      state = {
        ...state,
        user: null,
        permissions: {},
        enabledModules: {},
        groups: [],
        isAuthenticated: false,
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
